import { Box, Stack, Typography, useColorScheme } from '@mui/material';
import { useAtom } from 'jotai';

import TicketProgressBars from '@/assets/ticket-progress-bars.svg';
import TicketProgressBarsLight from '@/assets/ticket-progress-bars-light.svg';
import TicketServiceProgressBars from '@/assets/ticket-service-progress-bars.svg';
import TicketServiceProgressBarsLight from '@/assets/ticket-service-progress-bars-light.svg';
import { TICKET_TYPE, ticketAtom } from '@/pages/Ticket';
import getDateTime from '@/utils/getDateTime.utils';

import convertTime from '../AvgAckTimeWidget/AvgAckTimeWidget.utils';
import useStyles from './TicketProgress.styles';

const TicketProgress = () => {
  const { classes } = useStyles();
  const { mode: themeMode } = useColorScheme();

  const [
    {
      time_to_detect,
      time_to_notify,
      ingested_at,
      time_to_acknowledge,
      time_to_remediate,
      time_to_close,
      published_at,
      ticket_type
    }
  ] = useAtom(ticketAtom);

  const timeToDetectDisplay = convertTime(
    time_to_detect / 60000 ? time_to_detect / 60000 : 0
  );
  const timeToNotifyDisplay = convertTime(
    time_to_notify / 60000 ? time_to_notify / 60000 : 0
  );
  const timeToAcknowledgeDisplay = convertTime(
    time_to_acknowledge / 60000 ? time_to_acknowledge / 60000 : 0
  );
  const timeToRemediateDisplay = convertTime(
    time_to_remediate / 60000 ? time_to_remediate / 60000 : 0
  );

  const timeToCloseDisplay = convertTime(
    time_to_close / 60000 ? time_to_close / 60000 : 0
  );

  return (
    <Box className={classes.progressOverlayContainer}>
      {ticket_type === TICKET_TYPE.THREAT && (
        <>
          <Box
            component="img"
            src={
              themeMode === 'dark'
                ? TicketProgressBars
                : TicketProgressBarsLight
            }
            alt="Pondurance"
            className={classes.svgContainer}
          />
          <Stack spacing={0} className={classes.overlayTextStack}>
            <Stack direction="row" sx={{ justifyContent: 'space-between' }}>
              <Typography className={classes.boxTitleText}>
                Ingested At:
              </Typography>
              <Typography className={classes.boxTimeText}>
                {ingested_at ? getDateTime(ingested_at) : '--'}
              </Typography>
            </Stack>
            <Stack direction="row" sx={{ justifyContent: 'space-between' }}>
              <Typography className={classes.boxTitleText}>
                Time to Detect:
              </Typography>
              <Typography className={classes.boxTimeText}>
                {time_to_detect > 0
                  ? `${timeToDetectDisplay.time} ${timeToDetectDisplay.unit}`
                  : '--'}
              </Typography>
            </Stack>
            <Stack direction="row" sx={{ justifyContent: 'space-between' }}>
              <Typography className={classes.boxTitleText}>
                Time to Notify:
              </Typography>
              <Typography className={classes.boxTimeText}>
                {time_to_notify > 0
                  ? `${timeToNotifyDisplay.time} ${timeToNotifyDisplay.unit}`
                  : '--'}
              </Typography>
            </Stack>
            <Stack direction="row" sx={{ justifyContent: 'space-between' }}>
              <Typography className={classes.boxTitleText}>
                Time to Acknowledge:
              </Typography>
              <Typography className={classes.boxTimeText}>
                {time_to_acknowledge > 0
                  ? `${timeToAcknowledgeDisplay.time} ${timeToAcknowledgeDisplay.unit}`
                  : '--'}
              </Typography>
            </Stack>
            <Stack direction="row" sx={{ justifyContent: 'space-between' }}>
              <Typography className={classes.boxTitleText}>
                Time to Remediate:
              </Typography>
              <Typography className={classes.boxTimeText}>
                {time_to_remediate > 0
                  ? `${timeToRemediateDisplay.time} ${timeToRemediateDisplay.unit}`
                  : '--'}
              </Typography>
            </Stack>
          </Stack>
        </>
      )}
      {ticket_type === TICKET_TYPE.SERVICE && (
        <>
          <Box
            component="img"
            src={
              themeMode === 'dark'
                ? TicketServiceProgressBars
                : TicketServiceProgressBarsLight
            }
            alt=""
            className={classes.svgContainer}
          />
          <Stack spacing={0} className={classes.overlayTextStack}>
            <Stack direction="row" sx={{ justifyContent: 'space-between' }}>
              <Typography className={classes.boxTitleText}>
                Created At:
              </Typography>
              <Typography className={classes.boxTimeText}>
                {published_at ? getDateTime(published_at) : '--'}
              </Typography>
            </Stack>
            <Stack direction="row" sx={{ justifyContent: 'space-between' }}>
              <Typography className={classes.boxTitleText}>
                Time to Acknowledge:
              </Typography>
              <Typography className={classes.boxTimeText}>
                {time_to_acknowledge > 0
                  ? `${timeToAcknowledgeDisplay.time} ${timeToAcknowledgeDisplay.unit}`
                  : '--'}
              </Typography>
            </Stack>
            <Stack direction="row" sx={{ justifyContent: 'space-between' }}>
              <Typography className={classes.boxTitleText}>
                Time to Close:
              </Typography>
              <Typography className={classes.boxTimeText}>
                {time_to_close > 0
                  ? `${timeToCloseDisplay.time} ${timeToCloseDisplay.unit}`
                  : '--'}
              </Typography>
            </Stack>
          </Stack>
        </>
      )}
    </Box>
  );
};

export default TicketProgress;
